import { render, staticRenderFns } from "./OrderNotificationPopup.vue?vue&type=template&id=60c75872"
import script from "./OrderNotificationPopup.vue?vue&type=script&lang=js"
export * from "./OrderNotificationPopup.vue?vue&type=script&lang=js"
import style0 from "./OrderNotificationPopup.vue?vue&type=style&index=0&id=60c75872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports